import { useEffect, useRef, useState } from 'react';

export default function ActionMenu({ onView, onEdit, onDelete }) {
  const [open, setOpen] = useState(false);
  const menuRef = useRef();

  useEffect(() => {
    const handler = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, []);

  return (
    <div className="relative" ref={menuRef}>
      <button
        onClick={() => setOpen(!open)}
        className="text-gray-500 hover:text-gray-800 focus:outline-none"
      >
        ⋮
      </button>

      {open && (
        <div className="absolute right-0 z-10 mt-2 w-28 bg-white border border-gray-200 rounded shadow-lg">
          <ul className="py-1 text-sm text-gray-700">
            <li>
              <button
                onClick={() => {
                  onView();
                  setOpen(false);
                }}
                className="block w-full text-left px-4 py-2 hover:bg-gray-100"
              >
                View
              </button>
            </li>
            <li>
              <button
                onClick={() => {
                  onEdit();
                  setOpen(false);
                }}
                className="block w-full text-left px-4 py-2 hover:bg-gray-100"
              >
                Edit
              </button>
            </li>
            <li>
              <button
                onClick={() => {
                  onDelete();
                  setOpen(false);
                }}
                className="block w-full text-left px-4 py-2 hover:bg-gray-100 text-red-600"
              >
                Delete
              </button>
            </li>
          </ul>
        </div>
      )}
    </div>
  );
}
